import { Container } from 'react-bootstrap';

const Section = ({ className = '', variant = 'default', children, ...props }) => {
  return (
    <section className={`section-block section-${variant} ${className}`.trim()} {...props}>
      <Container>{children}</Container>
    </section>
  );
};

export default Section;
